import { typeSafeAssign } from '@/utils/common'
import { computed, makeObservable, observable } from 'mobx'
import { EMPTY_NUMBER_ID, EMPTY_STRING_ID } from 'src/constant/common'

import { DTO } from '../DTO'
import { ProblemScoringExam } from './ProblemScoringExam'

export class GroupStudentProblem extends DTO {
  id: res.GroupStudentExamResult['id'] = EMPTY_NUMBER_ID
  studentId: res.GroupStudentExamResult['studentId'] = EMPTY_STRING_ID
  studentName: res.GroupStudentExamResult['studentName'] = ''
  scoringList: ProblemScoringExam[] = [
    new ProblemScoringExam({
      examProblemId: 0,
      result: 'CORRECT',
      score: 0,
    }),
  ]

  constructor(data: Omit<res.GroupStudentExamResult, 'status' | 'score'>) {
    super()
    makeObservable(this, {
      id: observable,
      studentId: observable,
      studentName: observable,
      scoringList: observable,
      score: computed,
      status: computed,
    })

    if (data)
      typeSafeAssign(this, {
        studentId: data.studentId,
        studentName: data.studentName,
        id: data.id,
        scoringList: data.scoringList.map((scoring) => {
          return new ProblemScoringExam({
            examProblemId: scoring.examProblemId,
            result: scoring.result,
            score: scoring.score,
          })
        }),
      })
  }

  get score() {
    return this.scoringList.reduce((acc, scoring) => {
      if (scoring.result === 'CORRECT') {
        return acc + scoring.score
      }
      return acc
    }, 0)
  }

  get status() {
    if (this.scoringList.every((scoring) => scoring.result !== 'NONE')) {
      return 'COMPLETE'
    }
    if (this.scoringList.some((scoring) => scoring.result !== 'NONE')) {
      return 'PROGRESS'
    }

    return 'INCOMPLETE'
  }
}
